export default window;